import { useState } from "react";
import { IconButton, Typography, makeStyles } from "@material-ui/core";
import { ConsultantKarensItem } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { Color, DatePicker, DeleteIcon, TextField } from "@bonliva-crm/ui";

export const KarensCard = (props: {
  karens: ConsultantKarensItem;
  index: number;
  updateValues: (k: ConsultantKarensItem, i: number) => void;
  deleteKarens: (i: number) => void;
}) => {
  const classes = useStyles();
  const [date, setDate] = useState<Date | null>(
    props.karens.expDate ? new Date(props.karens.expDate) : null
  );
  const [region, setRegion] = useState(props.karens.region);

  return (
    <div className={classes.karensCardWrapper}>
      <div className={classes.karensCardTopWrapper}>
        <Typography variant="h6">
          {locale.Karens} {props.index + 1}
        </Typography>
        <IconButton onClick={() => props.deleteKarens(props.index)}>
          <DeleteIcon htmlColor={Color.PrimaryMain} />
        </IconButton>
      </div>
      <TextField
        InputProps={{
          style: {
            backgroundColor: Color.White
          }
        }}
        className={classes.karensCardInputs}
        label={locale.Region}
        value={region}
        onChange={(e) => {
          setRegion(e.target.value);
          props.updateValues({ ...props.karens, region: e.target.value }, props.index);
        }}
      />
      <DatePicker
        className={classes.karensCardInputs}
        value={date}
        onChange={(date) => {
          setDate(date);
          props.updateValues(
            { ...props.karens, expDate: date.toISOString() },
            props.index
          );
        }}
        label={locale.DateKarensExp}
        inputProps={{
          style: {
            backgroundColor: Color.White
          }
        }}
      />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  karensButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxShadow: "none",
    padding: 0,
    gap: "0.25rem"
  },
  addKarensButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxShadow: "none",
    "& span": {
      gap: "0.5rem"
    }
  },
  textWrapper: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "0.25rem"
  },
  iconButton: {
    padding: 0
  },
  karensCardWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    backgroundColor: Color.OffWhite,
    borderRadius: "4px",
    border: `1px solid ${Color.LightGray}`,
    padding: "1rem",
    boxSizing: "border-box"
  },
  karensCardTopWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  karensCardInputs: {
    "& .react-datepicker__input-container": {
      "& input": {
        backgroundColor: `${Color.White} !important`
      }
    }
  }
}));
